import { Link } from 'react-router-dom';

interface Spotlight {
  key: string;
  src: string;
  alt: string;
  to: string;
}

// Card promozionali fornite da Vincenzo (2:3). Usate 1:1 come immagini cliccabili.
const SPOTLIGHTS: Spotlight[] = [
  {
    key: 'bonus',
    src: '/images/spotlight-bonus.jpg',
    alt: 'Scopri i nostri bonus: benvenuto, cashback, compleanno, porta un amico',
    to: '/my/promozioni',
  },
  {
    key: 'preferiti',
    src: '/images/spotlight-preferiti.jpg',
    alt: 'I tuoi consulenti ideali sempre a portata di click: salvali nei preferiti',
    to: '/my/preferiti',
  },
  {
    key: 'supporto',
    src: '/images/spotlight-supporto.jpg',
    alt: 'Scopri il supporto Klaro7 per account, consulti e pagamenti',
    to: '/my/supporto',
  },
  {
    key: 'lavora',
    src: '/images/spotlight-lavora.jpg',
    alt: 'Lavora con noi: unisciti alla piattaforma di consulenti Klaro7. Candidati ora',
    to: '/lavora-con-noi',
  },
];

function SpotlightCard({ s }: { s: Spotlight }) {
  return (
    <Link
      to={s.to}
      className="group block overflow-hidden rounded-xl border border-white/10 shadow-[0_2px_20px_rgba(35,31,85,0.18)] transition-all duration-300 hover:-translate-y-1 hover:border-brand-teal/30 hover:shadow-[0_8px_30px_rgba(35,31,85,0.3)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal/50"
    >
      <img
        src={s.src}
        alt={s.alt}
        width={832}
        height={1248}
        loading="lazy"
        decoding="async"
        className="aspect-[2/3] w-full object-cover transition-transform duration-500 ease-out group-hover:scale-[1.03]"
      />
    </Link>
  );
}

/**
 * Riga di 4 card "spotlight" (Bonus, Preferiti, Supporto, Lavora con noi)
 * pensata per chiudere la home affiancandosi alle card consulenti (4 col desktop).
 * Immagini fornite da Vincenzo, usate fedelmente.
 */
export function FeatureSpotlightRow() {
  return (
    <section className="px-4 pb-12" aria-label="Scopri Klaro7">
      <div className="mx-auto max-w-6xl">
        <div className="mb-4 flex items-center gap-3">
          <div className="h-px flex-1 bg-gradient-to-r from-brand-teal/30 to-transparent" />
          <h2 className="shrink-0 text-sm font-semibold uppercase tracking-widest text-brand-teal/70">
            Scopri Klaro7
          </h2>
          <div className="h-px flex-1 bg-gradient-to-l from-brand-teal/30 to-transparent" />
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {SPOTLIGHTS.map((s) => (
            <SpotlightCard key={s.key} s={s} />
          ))}
        </div>
      </div>
    </section>
  );
}
